/**
 * 서버 시각과 로컬 기기 시각의 오차(ms)를 계산 및 보정하여 반환하는 유틸리티
 */

export const getServerTimeOffset = (): number => {
  if (typeof window !== 'undefined') {
    return (window as any).serverTimeOffset || 0;
  }
  return 0;
};

export const getSyncedNow = (): number => {
  return Date.now() + getServerTimeOffset();
};
